import {
  ModuleRegistry,
  RowSelectionModule,
  PaginationModule,
  ClientSideRowModelModule,
} from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";

ModuleRegistry.registerModules([
  RowSelectionModule,
  PaginationModule,
  ClientSideRowModelModule,
]);

const AppTableAGgrid = ({ columns, onSelectChange, rows, isFetching }) => {
  const containerStyle = useMemo(
    () => ({ width: "100%", height: "600px" }),
    []
  );
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  const defaultColDef = useMemo(
    () => ({
      flex: 1,
      minWidth: 150,
      resizable: true,
    }),
    []
  );

  const rowSelection = useMemo(() => ({ mode: "multiRow" }), []);

  const dataTypeDefinitions = useMemo(
    () => ({
      currency: {
        extendsDataType: "text",
        baseDataType: "text",
        valueFormatter: (params) =>
          params.value == null ? "" : `${params.value.cur(0)}`,
      },
    }),
    []
  );

  const onSelectionChanged = useCallback(
    (params) => {
      const selectedData = params.api.getSelectedRows();
      const selectedIds = selectedData.map((r) => r.loanAccountNumber);
      onSelectChange?.(selectedIds);
    },
    [onSelectChange]
  );

  // Transform columns
  const [columnDefs, setColumnDefs] = useState([]);
  useEffect(() => {
    if (columns && columns.length > 0) {
      setColumnDefs(
        columns.map((col) => ({
          field: col.dataIndex,
          headerName: col.title,
          cellDataType: col.type,
          ...(col.type === "date" && {
            valueFormatter: (params) =>
              params.value
                ? moment(new Date(params.value)).format("DD-MM-YYYY")
                : "",
          }),
          ...(col.render && { cellRenderer: col.render }),
        }))
      );
    }
  }, [columns]);

  return (
    <div style={containerStyle}>
      <div style={gridStyle}>
        <AgGridReact
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          rowData={rows}
          rowSelection={rowSelection}
          onSelectionChanged={onSelectionChanged}
          rowModelType="clientSide"
          pagination={true}
          paginationPageSize={100} // client-side paging
          paginationPageSizeSelector={[10, 20, 50, 100, 500]}
          dataTypeDefinitions={dataTypeDefinitions}
          loading={isFetching}
        />
      </div>
    </div>
  );
};

export default AppTableAGgrid;
